import React from "react";
import { Table,  Popconfirm, Image , Tag} from "antd";
import { ColumnType } from "antd/es/table";
import { RiDeleteBin6Line } from "react-icons/ri";

import MyPagination from "../../../components/Pagination";
import { IServicePayloadAndResponse } from "../../../../types/api/service";
import { FiEdit3 } from "react-icons/fi";
import { renderIcon, renderTableText } from "../../../../lib/utils";
import { useNavigate } from "react-router-dom";


interface ITeamPayloadAndResponseProps {
  data?: IServicePayloadAndResponse[];
  handleDelete?: (id: string) => void;
  form?: any;
  setIsEditing?: (value: boolean) => void;
  loading?: boolean;
  DEFAULT_NUQS_CONFIG?: any;
  qData?: any;
  refetch?: any;
}

const EditIcon = renderIcon(FiEdit3);
const DeleteIcon = renderIcon(RiDeleteBin6Line);


const ServiceTable: React.FC<ITeamPayloadAndResponseProps> = ({
  data = [],
  handleDelete = () => {},
  form = { setFieldsValue: () => {} },
  setIsEditing = () => {},
  loading = false,
  DEFAULT_NUQS_CONFIG,
  qData,
  refetch,
}) => {
 

  const navigate = useNavigate()


  const columns: ColumnType<IServicePayloadAndResponse>[] = [
   
     {
      title: "S.No.",
      dataIndex: "index",
      key: "index",
      render : (_,record,index) => renderTableText((index + 1).toString())
    },
    {
      title: "Title",
      dataIndex: "title",
      key: "title",
      render : (v) => renderTableText(v)
    },
    {
      title: "Image",
      dataIndex: "feature_image",
      key: "feature_image",
      render : (v) => {
        return (
          <div className=" h-[55px] w-[80px]">
            <Image src={v} alt="image" className="w-full h-full object-cover" />
          </div>
        )
      }
    },
     {
          title: "Order",
          dataIndex: "order",
          key: "order",
          render : (v) => renderTableText(v)
        },

        {
      title: "Status",
      dataIndex: "status",
      key: "status",
      render: (status: boolean) => (
        <Tag color={status ? "green" : "red"} bordered>
          {status ? "Active" : "Inactive"}
        </Tag>
      ),
    },
    {
      title: "Action",
      key: "action",
      align: "right",
      fixed: "right",
      render: (_: any, data: any) => (
        <div className="flex items-center justify-end gap-3">
          <EditIcon
            className="cursor-pointer text-primary text-[20px]"
            onClick={() => navigate(`/website/services/edit/${data?._id}`)}
          />

          <Popconfirm
            title="Are you sure to delete this row?"
            onConfirm={() => handleDelete?.(data?._id)}
            okText="Yes"
            cancelText="No"
          >
            <DeleteIcon className="cursor-pointer text-primary hover:text-red-600 text-[20px]" />
          </Popconfirm>
        </div>
      ),
    },
  ];

 return (
  <div>
    <div>
      <Table
        dataSource={data || []}
        columns={columns}
        rowKey={(item: any) => item?._id}
        pagination={false}
        size="middle"
        bordered={false}
        loading={loading}
        scroll={{ x: "max-content" }}
        className="custom-table-class rounded-lg border border-gray-200 shadow-md"
         footer={() => <MyPagination qData={qData} onChange={refetch} total={qData.total} DEFAULT_NUQS_CONFIG={DEFAULT_NUQS_CONFIG} />}
      />
    </div>
  </div>
);

};

export default ServiceTable;
